import styled from 'styled-components';
import { colors, media } from '@prisjakt/ui-base';

export const PlaceholderRow = styled.div`
  border-bottom: 1px solid ${colors.lightGray1};
  display: flex;
  height: 64px;
  padding: 15px 0;
  width: 100%;
`;

const PlaceholderBox = styled.div`
  background: ${colors.lightGray1};
  border-radius: 3px;
  height: 100%;
`;

export const ShopPlaceholder = styled(PlaceholderBox)`
  margin-right: 10%;
  flex: 0 1 150px;
`;

export const StockAndPricePlaceholder = styled(PlaceholderBox)`
  margin-left: auto;
  flex: 0 1 150px;
`;

export const CallToActionPlaceholder = styled(PlaceholderBox)`
  flex: 0 0 25px;
  margin-left: 10%;
  ${media.largeUp`
    margin-right: 15px;
    flex: 0 0 130px;
  `};
`;

export const PriceRowWrapper = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
`;

export const PriceRowTable = styled.table`
  width: 100%;
  border-spacing: 0;
  table-layout: fixed;
  ${media.mediumDown`
    thead th > div {
      height: 0;
      visibility: hidden;
    }
  `}
`;

export const PriceRowTableHeadExpand = styled.th`
  width: 50px;
  ${media.smallOnly`
    width: 35px;
  `}
`;
export const PriceRowTableHeadStore = styled.th`
  width: 108px;
`;
export const PriceRowTableHeadProduct = styled.th`
  width: auto;
`;
export const PriceRowTableHeadStock = styled.th`
  width: 10%;
`;
export const PriceRowTableHeadPrice = styled.th`
  width: 18%;
  ${media.mediumDown`
    width: 25%;
  `}
`;
export const PriceRowTableHeadClickOut = styled.th`
  width: 200px;
  ${media.mediumDown`
    width: 55px;
  `}
  ${media.smallOnly`
    width: 40px;
  `}
`;
